import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './styles';
import '../../css/ui-elements/breadcrumbs.css';

export default class Breadcrumbs extends Component {

  constructor(props) {
    super(props);
    this.getList = this.getList.bind(this);
  }

  getList() {
    const list = this.props.list;
    const arrLi = [];
    let className = '';

    for (let i = 0; i < list.length; i++) {
      const { name, eventOnClick, url, icon, style } = list[i];
      const link = eventOnClick
        ? <span style={{
          cursor: 'pointer',
        }} onClick={eventOnClick}>{name}</span>
        : <a href={url}>{name}</a>;

      arrLi.push(
        <li key={i}>
          <i className="material-icons" style={{
            position: 'relative',
            top: '5px',
            right: '3px',
            fontSize: '20px',
            ...style,
          }}>{icon}</i>
          {link}
        </li>
      );
    }

    return arrLi;
  }

  render() {
    const containerClass = `form-group ${this.props.className}`;
    return (
      <div className={containerClass}>
        <ol className="breadcrumb icon-angle-double-right">
          {this.getList()}
        </ol>
      </div>
    );
  }
}

Breadcrumbs.propTypes = {
  list: PropTypes.array,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/Breadcrumbs/index.js